import MySuppliersContainer from "../../Containers/MySuppliers";

const MySuppliers = () => {
  return <MySuppliersContainer />;
};

export default MySuppliers;
